module.exports = __webpack_public_path__ + "img/card_bogotaarchitectural_background.ced7a755.png";